import * as React from "react";
import formatDate from "dateformat";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  YAxis,
  Tooltip,
  CartesianGrid,
  XAxis,
} from "recharts";
import { transparentize } from "polished";
import { GetResponseTimeSeriesByCountry_responsesTimeSeriesByCountry_data } from "../../../../../apollo-types/GetResponseTimeSeriesByCountry";
import { TooltipContainerStyles } from "../../../../design-tokens/charts";
import { Colors, RainBow } from "../../../../design-tokens/colors";

interface ResponseSeriesTableBodyProps {
  startDate: string;
  responseTimeSeries: GetResponseTimeSeriesByCountry_responsesTimeSeriesByCountry_data[];
}

const ResponseSeriesTableBody: React.FC<ResponseSeriesTableBodyProps> = ({
  startDate,
  responseTimeSeries,
}) => {
  const firstCaseIndex = Math.max(
    0,
    responseTimeSeries.findIndex((r) => r.date === startDate)
  );
  const dataToPlot = responseTimeSeries.slice(
    firstCaseIndex,
    responseTimeSeries.length
  );

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={dataToPlot}
        margin={{ top: 20, bottom: 20, left: 0, right: 0 }}
      >
        <YAxis
          domain={[0, 100]}
          hide={true}
          scale="linear"
          padding={{ top: 0, bottom: 0 }}
        />

        <XAxis dataKey="date" hide={true} />

        <CartesianGrid
          vertical={false}
          horizontalPoints={[80, 160, 240, 320]}
          stroke={transparentize(0.7, Colors.MidGrey)}
        />

        <Line
          type="basis"
          dataKey="governmentResponseIndexForDisplay"
          name="Government response Index (All)"
          stroke="#FF9C07"
          strokeWidth={2}
          connectNulls={true}
          dot={false}
        />

        <Line
          type="basis"
          dataKey="containmentHealthIndexForDisplay"
          name="Containment health Index (C, H)"
          stroke={Colors.Red}
          strokeWidth={2}
          connectNulls={true}
          dot={false}
        />

        <Line
          type="basis"
          dataKey="stringencyIndexForDisplay"
          name="Stringency Index (C, H1)"
          stroke={RainBow.GrassGreen}
          strokeWidth={2}
          connectNulls={true}
          dot={false}
        />

        <Line
          type="basis"
          dataKey="economicSupportIndexForDisplay"
          name="Economic support Index (E)"
          stroke={RainBow.SkyBlue}
          strokeWidth={2}
          connectNulls={true}
          dot={false}
        />

        <Tooltip
          labelFormatter={(date) => formatDate(date, "mmm d")}
          cursor={false}
          contentStyle={TooltipContainerStyles}
          itemStyle={{ paddingBottom: 0 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ResponseSeriesTableBody;
